<template>
  <main class="rate">
    <div class="container">
      <div v-if="!loading">
        <div class="jumbotron"><h3>Ajoutez un nouveau taux</h3><hr/><rateForm :payload="rate" @submit="onAdd"/></div>
        <rateList :objects="rates" @show="onShow"/>
      </div>
      <loader v-else/>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

let rateForm = {
  props: {
    payload: Object
  },
  template: `
  <form @submit.prevent="$emit('submit', payload)">
     <div class="form-row">
        <div class="form-group col-sm-4">
          <input type="text" v-model="payload.inter" class="form-control" placeholder="Transfer">
        </div><div class="form-group col-sm-4">
          <input type="text" v-model="payload.sortie" class="form-control" placeholder="Retrait">
        </div><div class="form-group col-sm-4">
          <button type="submit" class="btn btn-outline-warning btn-block">Create</button>
        </div>
      </div>
  </form>
  `
};

let rateList = {
  props: {
    objects: Array
  },
  template: `
  <table class="table table-striped">
    <thead class="thead-dark">
      <tr>
        <th scope="col">#</th>
        <th scope="col">Transfer</th>
        <th scope="col">Retrait</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="obj in objects" :key="obj.id" @click.prevent="$emit('show', obj)">
        <th scope="row">{{obj.id}}</th>
        <td>{{obj.inter}}</td>
        <td>{{obj.sortie}}</td>
      </tr>
    </tbody>
  </table>
  `
};

let name = 'resource';
export default {
  name,
  data() {
    return {loading: true, rate: {}}
  },
  computed: {
    ...mapGetters(name, {rates: 'RATES'}),
  },
  methods: {
    ...mapActions(name, ['insertRate','fetchRate','removeRate']),
    onAdd(value){
      this.loading = true;
      this.insertRate(value).then(() => {this.loading = false; this.rate = {}});
    },
    onShow(value){
      this.rate = { ...value };
    },
    onDrop(value){
      if(confirm(`Are you sure you want to delete ${value.id} ?`)) this.removeRate(this.rate);
    }
  },
  created() { this.fetchRate().then(() => this.loading = false); },
  components: {rateForm, rateList}
}
</script>

<style scoped lang="scss"></style>
